import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchFlag } from './Flag.helper.js';
import { FlagContainer } from './Flag.styles.js';
import { ICON_SIZES } from '../../constants/sizes.js';
import { FLAG_MAPPING } from './Flag.mapping.js';

var FLAG_MAPPING_KEYS = Object.keys(FLAG_MAPPING);
var Flag = function Flag(_ref) {
  var countryCode = _ref.countryCode,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var iconSize = ICON_SIZES[size];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    flag = _useState2[0],
    setFlag = _useState2[1];
  useEffect(function () {
    fetchFlag(countryCode.toLowerCase()).then(function (countryFlag) {
      if (countryFlag === null) {
        console.warn("Kitbag-components does not contain a Flag SVG for ".concat(countryCode, "."));
      }
      setFlag(countryFlag);
    });
  }, [countryCode]);
  return flag && React__default.createElement(FlagContainer, {
    $width: iconSize,
    $height: iconSize,
    "data-testid": testId
  }, flag);
};
Flag.propTypes = {
  countryCode: PropTypes.oneOf(FLAG_MAPPING_KEYS).isRequired,
  size: PropTypes.oneOf(Object.keys(ICON_SIZES)),
  testId: PropTypes.string
};

export { Flag };
//# sourceMappingURL=Flag.js.map
